import { createTheme, responsiveFontSizes } from "@mui/material/styles";

const colors = {
  primary: {
    main: "#2E5E4E",
    contrastText: "#FFFFFF",
    light: "#8FBFA7",
    dark: "#1F3F36",
  },
  secondary: {
    main: "#8FBC8F",
    contrastText: "#FFFFFF",
    light: "#F3B774",
    dark: "#B26A1A",
  },
  warning: {
    main: "#FFD166",
    contrastText: "#023047",
  },
  error: {
    main: "#FB8500",
    contrastText: "#FFFFFF",
  },
  info: {
    main: "#7A9E9F",
    contrastText: "#FFFFFF",
  },
  success: {
    main: "#6DA34D",
    contrastText: "#FFFFFF",
  },
  background: {
    default: "#FFFFFF",
    paper: "#FFFFFF",
    subtle: "#F3F3F3",
    paperRgb: "255, 248, 225", // Vastab #FFF8E1-le, kasutusel läbipaistvuse efektide jaoks
  },
  text: {
    primary: "#333333",
    secondary: "#5A5A5A",
    disabled: "#9E9E9E",
  },
  divider: "#D9D9D9",
  action: {
    hover: "#E6F0EA",
    selected: "#DDECE2",
    disabled: "#B0B0B0",
    disabledBackground: "#F0F0F0",
    focus: "#D46300",
  },
};

const typography = {
  fontFamily: "Poppins, sans-serif",
  h1: {
    fontSize: "3rem",
    fontWeight: 600,
    "@media (min-width:600px)": { fontSize: "3.5rem" },
    "@media (min-width:960px)": { fontSize: "4rem" },
  },
  h2: {
    fontSize: "2.5rem",
    fontWeight: 600,
    "@media (min-width:600px)": { fontSize: "3rem" },
    "@media (min-width:960px)": { fontSize: "3.5rem" },
  },
  // h3: {
  //   fontSize: "2rem",
  //   "@media (min-width:600px)": {
  //     fontSize: "2.5rem",
  //   },
  //   "@media (min-width:960px)": {
  //     fontSize: "3rem",
  //   },
  // },
  // h4: {
  //   fontSize: "1.5rem",
  //   "@media (min-width:600px)": {
  //     fontSize: "2rem",
  //   },
  //   "@media (min-width:960px)": {
  //     fontSize: "2.5rem",
  //   },
  // },
  body1: {
    fontSize: "1rem",
    lineHeight: 1.6,
    fontWeight: 400,
  },
  logo: {
    fontFamily: "'Montserrat Alternates', sans-serif",
    fontWeight: 700,
    fontSize: "2rem",
    color: colors.primary.main,
  },
  shape: {
    borderRadius: 12,
  },
};

let theme = createTheme({
  palette: colors,
  typography,
  breakpoints: {
    values: { xs: 0, sm: 600, md: 960, lg: 1280, xl: 1920 },
  },
});

theme = responsiveFontSizes(theme);

export default theme;
